import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { IntelligentWideShot, photoCaptureIntelligentViewChangeAction, photoCaptureIntelligentPhotoUploadSuccessAction } from "../../../domain/photoCapture";
import { getQuestionnaireEvaluationQuestion } from "../../../domain/questionnaireEvaluation";
import { getGPCTheme } from '../selectors';
const mapStateToProps = (state, ownProps) => {
    return {
        appTheme: getGPCTheme(state),
        questionText: getQuestionnaireEvaluationQuestion(state)
    };
};
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        onViewChange: photoCaptureIntelligentViewChangeAction,
        onSelectedFileUpload: photoCaptureIntelligentPhotoUploadSuccessAction
    }, dispatch);
};
const IntelligentWideShotComponentWrapper = (props) => React.createElement(IntelligentWideShot, Object.assign({}, props));
export const ConnectedIntelligentWideShot = connect(mapStateToProps, mapDispatchToProps)(IntelligentWideShotComponentWrapper);
//# sourceMappingURL=ConnectedIntelligentWideShot.js.map